/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState } from "react";
import { FieldArray } from "formik";
import Icon from "components/Icon";
import { useTextMessage } from '@fitinsur/hooks';
import { GridColumnTitle } from "components/Form";
import {
  Table,
  TableHead,
  TableHeader,
  TableRow,
  TableBody,
  TableColumn,
  InlineLabel,
  LabelEdit
} from "./styles";
import moment from "moment";

const ImportPreview = ({ file }) => {
  const [sortBy, setSortBy] = useState({ key: null, direction: null });
  const { getDescription } = useTextMessage();

  const columns = [
    {
      title: getDescription("DOMAINS", 1141, { textFormat: 'uppercase'})
    },
    {
      title: getDescription("DOMAINS", 1142, { textFormat: 'uppercase'})
    },
    {
      title: getDescription("DOMAINS", 1143, { textFormat: 'uppercase'})
    },
    {
      title: getDescription("DOMAINS", 830, { textFormat: 'uppercase'})
    }
  ];


  return (
    <Table>
      <TableHead>
        {columns.map((column, index) => (
          <TableHeader
            key={index}
          >
          <GridColumnTitle>
            {column.title}
          </GridColumnTitle>
            { column.value &&
              sortBy.key === column.value &&
              sortBy.direction === "asc" ? (
                <Icon name={"arrowup"} />
              ) : column.value &&
                sortBy.key === column.value &&
                sortBy.direction === "desc" ? (
                <Icon name={"arrowdown"} />
              ) : ("")
            }
          </TableHeader>
        ))}
      </TableHead>
      <TableBody>
        <FieldArray name="currencies"
          render={() => (file && file.map((indexer, index) => (
            <TableRow key={index} error={indexer.error !== 'OK'}>
              <TableColumn>
                <InlineLabel>
                  {getDescription("DOMAINS", 1141)}
                </InlineLabel>
                <LabelEdit fontSize={12}>
                  {indexer.indexerCode}
                </LabelEdit>
              </TableColumn>
              <TableColumn>
                <InlineLabel>
                {getDescription("DOMAINS", 1142)}
                </InlineLabel>
                <LabelEdit fontSize={12}>
                  {indexer.indexerRate}
                </LabelEdit>
              </TableColumn>
              <TableColumn>
                <InlineLabel>
                {getDescription("DOMAINS", 1143)}
                </InlineLabel>
                <LabelEdit fontSize={12}>
                  {indexer.date ? moment(indexer.date).format('MM/YYYY') : getDescription("DOMAINS", 1144)}
                </LabelEdit>
              </TableColumn>
              <TableColumn>
                <InlineLabel>
                {getDescription("DOMAINS", 830)}
                </InlineLabel>
                <LabelEdit fontSize={12}>
                  {indexer.error}
                </LabelEdit>
              </TableColumn>
            </TableRow>
          )))}
        />
      </TableBody>
    </Table>
  );
};

export default ImportPreview;